import Router from 'next/router'
import { PageView, CurrentPath, InitializeAnalytics } from 'utils/Analytics'

class AnalyticsPageViewTracker {
  lastPath = null
  pageType = null
  routeChangeFunction = null
  ROUTE_CHANGE_COMPLETED = 'routeChangeComplete'

  constructor(pageType) {
    this.pageType = pageType
    const analyticsPageViewTracker = this
    this.routeChangeFunction = (path) => {
      analyticsPageViewTracker.pageView(path)
    }
  }

  pageView(path) {
    if (!path) {
      path = CurrentPath()
    }

    if (this.lastPath && this.lastPath === path) {
      return
    }

    this.lastPath = path

    PageView(path, { page_type: this.pageType }, this.router)
  }

  startTracking(router, domain) {
    InitializeAnalytics(domain, this.pageType)
    this.router = router
    this.lastPath = null
    this.pageView()
    Router.events.on(this.ROUTE_CHANGE_COMPLETED, this.routeChangeFunction)
  }

  stopTracking() {
    Router.events.off(this.ROUTE_CHANGE_COMPLETED, this.routeChangeFunction)
    this.lastPath = null
    this.router = null
  }
}

export default AnalyticsPageViewTracker
